import { MadSDKAPIError } from "../../../errors/base";
export class DmpSegmentsFetchFailed extends MadSDKAPIError {
    constructor(apiError) {
        super(apiError, "Failed to retrieve data management platform segments.");
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, DmpSegmentsFetchFailed);
        }
        this.name = "DmpSegmentsFetchFailed";
    }
}
export class DmpSegmentsUpsertFailed extends MadSDKAPIError {
    constructor(apiError) {
        super(apiError, "Failed to update data management platform segment(s).");
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, DmpSegmentsUpsertFailed);
        }
        this.name = "DmpSegmentsUpsertFailed";
    }
}
//# sourceMappingURL=errors.js.map